import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ConfirmDialogData {
  title?: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

@Component({
  selector: 'app-generic-confirmation-dialog',
  templateUrl: './generic-confirmation-dialog.component.html',
  standalone: false
})
export class GenericConfirmationDialogComponent {
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel: string;

  constructor(
    public dialogRef: MatDialogRef<GenericConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) {
    this.title = data?.title ?? 'Confirm';
    this.message = data?.message ?? 'Are you sure?';
    this.confirmLabel = data?.confirmLabel ?? 'Yes';
    this.cancelLabel = data?.cancelLabel ?? 'Cancel';
  }

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
